import { buildPathToStaticFolderOfCDN } from "utils/common";

const languages = ["AR", "DE", "FA", "TR", "RU", "HY", "EN", "ES", "HE", "FR", "KO", "RO", "PT", "BG", "BE", "SR", "EL"];
const languageFlags = languages.reduce((acc, language) => {
	acc[language] = buildPathToStaticFolderOfCDN(`cashier-images/language/${language}.svg`)
	return acc
}, {})

export default languageFlags;
